import React,{useState} from "react";
import styled from "styled-components";
import { TextFont, Colors } from "../config";

const Button = ({
  label,
  onClick,
  leftImgSrc,
  rightImgSrc,
  disabled = false,
  bgColor = Colors.brandTwo,
  borderRadius = "2.5rem",
  width = "100%",
  topBottomPadding = "0rem",
  fontColor = Colors.white,
  fontSize = "1.125rem",
  fontWeight = "600",
  outlineColor,
  labelImgGap = "1rem",
  leftRightPadding,
}) => {
    const [debounceDisable, setDebounceDisable] = useState(false);
  const handleClick = (e) => {
    onClick(e);
    setDebounceDisable(true);
    setTimeout(() => {
      setDebounceDisable(false);
    }, 1500);
  };

  return (
    <StyledButton
      onClick={handleClick}
      disabled={disabled || debounceDisable}
      bgColor={bgColor}
      outlineColor={outlineColor}
      width={width}
      topBottomPadding={topBottomPadding}
      borderRadius={borderRadius}
      leftRightPadding={leftRightPadding}
    >
      <DisplayFlexRow labelImgGap={labelImgGap}>
        {leftImgSrc && <img src={leftImgSrc} alt="button-left-img" />}
        <TextFont
          fontColor={fontColor}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {label}
        </TextFont>
        {rightImgSrc && <img src={rightImgSrc} alt="button-right-img" />}
      </DisplayFlexRow>
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled.button`
  border: none;
  background: ${(props) => props.bgColor};
  border: ${(props) =>
    props.outlineColor ? "1px solid " + props.outlineColor : "none"};
  border-radius: ${(props) => props.borderRadius};
  width: ${(props) => props.width};
  padding-left: ${(props) => props.leftRightPadding};
  padding-right: ${(props) => props.leftRightPadding};
  padding-top: ${(props) => props.topBottomPadding};
  padding-bottom: ${(props) => props.topBottomPadding};
  cursor: pointer;
  :disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
const DisplayFlexRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${(props) => props.labelImgGap}; ;
`;
